import { defineStore } from 'pinia'
import { useAgencyStore } from '@/stores/agency'
// import { useProviderStore } from '@/stores/providers'
// const providerStore = useProviderStore()
import { availValidationData } from './utl.js'
import cancellationPoliciesDummy from './cancellationPolicies.json'
// front/src/stores/hotels/juniper/cancellationPolicies.js
import axios from '@/plugins/axios'

export default defineStore('hotelsJuniper', {
  state: () => ({
    hotel: {
      _id: '',
      active: false,
      checkIn: '',
      checkOut: '',
      lowestPrice: 0,
      highestPrice: 0,
      services: [],
      images: [],
      certified: false,
      release: 0,
      name: '',
      description: {},
      place: '',
      placeAddress: '',
      city: '',
      cityName: '',
      category: '',
      bookingCode: '',
      agency: '',
      createdAt: '',
      updatedAt: '',
      offers: []
    },
    reserve: {
      hotel: {},
      start: '',
      end: '',
      companions: [],
      room: {},
      payments: {},
      holder: {},
      price: 0,
      isGuest: false,
      indexPayer: -1,
      bookingCode: '',
      countryCode: '',
      country: '',
      comments: '',
      observations: '',
      destination: {},
      cancellationPolicies: []
    },
    errors: [],
    paxes:[{
      numberOfPeople: 2,
      children: 0,
      childrenAge: [],
      adults: 2,
      adultsAge: [30, 30]
    }],
    hotelContent: {},
    payments: {},
    changedAges: {},
    isAgeChange: false,
    hotels: [],
    rangePrice: [0, 0],
    cancelPolicies: {},
    isQuery: false,
    modal: false,
    cancellationPolicyDialog: false,
    hotelPreviewDialog: false,
    country: '',
    countryCode: '',
    queryMode: '',
    itemsFound: 0,
    expires: 0,
    start: '',
    end: '',
    keyword: '',
    provider_id: '',
    destination: {},
    numberOfAdults: 2,
    numberOfChildren: '',
    totalNumberOfPeople: 2,
    nights: 2,
    provider: '',
    providers: [],
    version: '2.0.0'
  }),
  actions: {
    async simulate(cbk) {
      let itemsFound = 0
      let lowestPrice = 0
      let highestPrice = 0
      let hotels = []
      const modes = {
        'hotels': 'normal',
        'hotels-disney': 'disney',
        'hotels-universal': 'universal',
      }

      const mode_query = modes[mode]

      const url = `api/v1/hotel/avail/simulate`
      let hotels_response = await axios.post(`${url}`, { mode: mode_query })
      const { success = false, expires = 0 } = { ...hotels_response?.data }

    

      if (success) {
        const hotelsResponse = hotels_response.data.response
        hotels = hotelsResponse?.data?.hotels || []

        if (hotels?.length) {
          itemsFound = hotelsResponse?.data?.itemsFound || 0
          lowestPrice = hotelsResponse?.data?.lowestPrice || 0
          highestPrice = hotelsResponse?.data?.highestPrice || 0
        }
      }
      this.hotels = hotels
      this.lowestPrice = lowestPrice
      this.highestPrice = highestPrice
      this.expires = expires
      this.itemsFound = itemsFound
      this.rangePrice = [lowestPrice, highestPrice]
      this.preload = true
      if( typeof cbk === 'function') cbk(hotels)
    },
    async getAvail(mode, cbk) {
      const modes = {
        'hotels': 'normal',
        'hotels-disney': 'disney',
        'hotels-universal': 'universal',
      }
      const mode_query = modes[mode]
      let url = `api/search/new-avail`
      let response = null

      this.isQuery = false
      this.errors = []
      const agencyStore = useAgencyStore()
      const test = agencyStore?.mode === 'production' ? false : true
      const start = this.start
      const end = this.end
      const paxes = this.paxes
      const country = this.country
      const countryCode = this.countryCode
      const keyword = this.keyword
      const destination = this.destination
      const numberOfAdults = this.numberOfAdults
      const numberOfChildren = this.numberOfChildren
      const totalNumberOfPeople = this.totalNumberOfPeople
      const providers = this.providers

      const { adultsAge: adults = [], childrenAge: children = [] } = { ...paxes }

      const errors = availValidationData({
        start,
        end,
        paxes: paxes,
        countryCode,
        country,
        keyword,
        destination,
        numberOfAdults,
        numberOfChildren,
        totalNumberOfPeople,
        providers,
        mode: mode_query
      })

      
      if (errors.errors) {
        this.errors = errors.data
        if( typeof cbk === 'function') cbk()
        return
      }

      const data = {
        providers: [this.provider_id],
        countryCode,
        city: country,
        keyword,
        destination,
        numberOfAdults,
        numberOfChildren,
        totalNumberOfPeople,
        dateFrom: start,
        dateTo: end,
        rooms: paxes,
        nights: this.nights,
        category: [],
        typeRaiting: [],
        simulate: test,
        mode: mode_query
      }

      this.preload = true
      this.hotels = []

      response = await axios.post(`${url}`, data)

      const { success = false, response: hotelResponse = {} } = { ...response?.data }

      const {
        lowestPrice = 0,
        highestPrice = 0,
        itemsFound = 0,
        expires = 0,
        currency = 'USD',
        hotels = []
      } = { ...hotelResponse }

      if( typeof cbk === 'function') cbk(hotels)

      if (success) {
        this.hotels = hotels
        this.lowestPrice = lowestPrice
        this.highestPrice = highestPrice
        this.expires = expires
        this.currency = currency
        this.itemsFound = itemsFound
        this.rangePrice = [lowestPrice, highestPrice]
        this.isQuery = true
        this.preload = true
      }
     setTimeout(() => {
      if( typeof cbk === 'function') cbk(hotels)
     }, 300);
    },
    async avail(mode, cbk) {
      const agencyStore = useAgencyStore()
      const test = agencyStore?.mode === 'production' ? false : true
      if (test) {
        this.simulate(mode, cbk)
      } else {
        this.getAvail(mode, cbk)
      }
    },
    async getHotelContent(payload) {
      let content = {}
      const agencyStore = useAgencyStore()
      if (agencyStore?.mode !== 'production') {
        let url = `/api/v1/hotel/content/simulate`
        const response = await axios.post(url, { mode: 'normal' })
        content = response?.data?.response.data
      } else {
        let url = `/api/search/get-hotel-content`
        const response = await axios.post(`${url}`, payload)
        content = response?.data?.response
      }
      return content
    },
    async getHotelOnliAvail(payload) {
      const agencyStore = useAgencyStore()
      if (agencyStore?.mode !== 'production') {
        return this.simulateHotelOnlyAvail({ mode: 'normal' })
      }

      let url = `/api/search/new-avail`
      const { provider, JPCode } = payload
      const data = await this.prepareData()

      const post = Object.assign({}, data, {
        destination: {
          type: 'jpcodes',
          jpcodes: [JPCode]
        },
        providers: [provider]
      })

      let response = await axios.post(`${url}`, post)
      return response?.data
    },
    async simulateHotelOnlyAvail(query) {
      let url = `/api/v1/hotel/avail/simulate`
      const response = await axios.post(url, { ...query })
      return response.data
    },
    prepareData() {
      return {
        mode: this.queryMode,
        destination: this.destination,
        keyword: this.keyword,
        nights: this.nights,
        category: this.typeRaiting,
        typeRaiting: this.typeRaiting,
        dateFrom: this.start,
        dateTo: this.end,
        countryCode: this.countryCode,
        cityCode: this.countryCode,
        country: this.country,
        city: this.country,
        numberOfChildren: this.numberOfChildren,
        numberOfAdults: this.numberOfAdults,
        numberOfRooms: this.numberOfRooms,
        totalNumberOfPeople: this.totalNumberOfPeople,
        rooms: this.rooms,
        provider: this.provider_id,
        providers: this.providers
      }
    },
    async cancellationPolices(payload) {
      // getBookingRules
      const agencyStore = useAgencyStore()
      const test = agencyStore?.mode === 'sandbox'


      if (test) {
        return cancellationPoliciesDummy
      }
      try {
        const { JPCode, planComboCode, provider } = payload

        const start = this.start
        const end = this.end

        let body = {
          Code: JPCode,
          provider: test ? 'SANDBOX' : provider,
          RatePlanCode: planComboCode,
          Start: start,
          End: end
        }

        let url = '/api/booking/flow-j/get-booking-rules'

        if (test) url = `${url}/simulate`

        let response = await axios.post(url, body)

        if (!response.data.error) {
        }

        return response.data
      } catch (er) {
        console.log('Error pidiendo booking-rules', er)
      }
    },

    async booking({isEstimate = false}) {
      const url = `api/booking/flow-j/post-booking`

      const companions = this.reserve?.companions
        .map((comp) => {
          if (comp.idPax !== this.reserve.indexPayer)
            return {
              name: comp.name,
              lastName: comp.surname,
              age: comp.age
            }
        })
        .filter((comp) => comp)

      const data = {
        hotelCode: `${this.reserve?.hotel?.code}`,
        provider: this.provider_id,
        //bookingInfo: this.reserve.hotel,
        bookingCode: this.reserve?.cancellationPolicies.bookingCode,
        start: this.start,
        end: this.end,
        destination: this.destination,
        priceInfo: this.reserve?.cancellationPolicies?.priceInfo?.price,
        form: {
          companions,
          name: `${this.reserve?.holder?.name}`,
          surname: `${this.reserve?.holder?.surname}`,
          email: `${this.reserve?.holder?.email}`,
          address: `${this.reserve?.holder?.address}`,
          document: this.reserve?.holder?.document,
          documentType: this.reserve?.holder?.documentType,
          age: this.reserve?.holder?.age,
          //country: this.country,
          city: this.reserve?.holder?.city,
          postalCode: this.reserve?.holder?.postalCode,
          nationality: this.countryCode,
          phones: [this.reserve?.holder?.phone],
          isGuest: this.reserve.isGuest
        },
        payments: this.payments,
        rooms: this.paxes,
        comments: this.reserve?.cancellationPolicies?.comments,
        commentsType: 'HOT',
        observations: this.reserve?.observations,
        test: this.test,
        isEstimate
      }

      return await axios.post(`${url}`, data)
    },

    async startReservation(payload) {
      const {
        companions = [],
        payments = {},
        cancellationPolicies = {},
        bookingCode = '',
        room = {},
        hotel = {}
      } = payload

      const start = this.start || ''
      const end = this.end || ''
      const countryCode = this.countryCode || ''
      const country = this.country || ''
      const destination = this.destination || {}

      const reserve = {
        hotel,
        start,
        end,
        companions,
        rooms: [room],
        room: room,
        payments,
        countryCode,
        price: room?.price,
        country,
        destination,
        cancellationPolicies,
        bookingCode
      }

      this.saveReserve(reserve)

      return {
        status: true,
        message: ''
      }
    },
    saveReserve(payload) {
      const {
        hotel = {},
        room = {},
        start = '',
        end = '',
        companions = [],
        payments = {},
        holder = {
          name: ``,
          email: '',
          address: ``,
          document: '',
          documentType: '',
          age: '',
          country: '',
          city: '',
          postalCode: '',
          nationality: '',
          phones: []
        },
        price = 0,
        countryCode = '',
        bookingCode = '',
        country = '',
        destination = '',
        cancellationPolicies = ''
      } = payload

      this.reserve.hotel = hotel
      this.reserve.start = start
      this.reserve.end = end
      this.reserve.companions = companions
      this.reserve.payments = payments
      this.reserve.price = price
      this.reserve.countryCode = countryCode
      this.reserve.country = country
      this.reserve.destination = destination
      this.reserve.holder = holder
      this.reserve.bookingCode = bookingCode
      this.reserve.cancellationPolicies = cancellationPolicies
      this.reserve.room = room
      this.reserve.comments = ''
    },
    async addReserve(payload) {
      let { id, hotel, planCode } = payload

      hotel['id'] = id
      hotel['selectedPlan'] = planCode

      this.reserve = hotel
    },
    saveReserve(payload) {
      const {
        hotel = {},
        room = {},
        start = '',
        end = '',
        companions = [],
        payments = {},
        holder = {
          name: ``,
          email: '',
          address: ``,
          document: '',
          documentType: '',
          age: '',
          country: '',
          city: '',
          postalCode: '',
          nationality: '',
          phones: []
        },
        price = 0,
        countryCode = '',
        bookingCode = '',
        country = '',
        destination = '',
        cancellationPolicies = ''
      } = payload

      this.reserve.hotel = hotel
      this.reserve.start = start
      this.reserve.end = end
      this.reserve.companions = companions
      this.reserve.payments = payments
      this.reserve.price = price
      this.reserve.countryCode = countryCode
      this.reserve.country = country
      this.reserve.destination = destination
      this.reserve.holder = holder
      this.reserve.bookingCode = bookingCode
      this.reserve.cancellationPolicies = cancellationPolicies
      this.reserve.room = room
    }
  },
  persist: true
})


